export enum AuditGridColumnId {
  // Negotiation fields
  NEGOTIATION_ORDER_ID = 'NEGOTIATION_ORDER_ID',
  NEGOTIATION_DIRECTION = 'NEGOTIATION_DIRECTION',
  NEGOTIATION_STATUS = 'NEGOTIATION_STATUS',
  NEGOTIATION_NOTIONAL = 'NEGOTIATION_NOTIONAL',
  NEGOTIATION_RATE = 'NEGOTIATION_RATE',
  NEGOTIATION_TERM = 'NEGOTIATION_TERM',
  NEGOTIATION_START_DATE = 'NEGOTIATION_START_DATE',
  NEGOTIATION_END_DATE = 'NEGOTIATION_END_DATE',
  NEGOTIATION_HAIRCUT_TYPE = 'NEGOTIATION_HAIRCUT_TYPE',
  NEGOTIATION_HAIRCUT = 'NEGOTIATION_HAIRCUT',
  NEGOTIATION_SETTLEMENT_VENUE = 'NEGOTIATION_SETTLEMENT_VENUE',
  NEGOTIATION_CSD = 'NEGOTIATION_CSD',
  NEGOTIATION_CALLABLE = 'NEGOTIATION_CALLABLE',
  NEGOTIATION_CALL_DAYS = 'NEGOTIATION_CALL_DAYS',
  NEGOTIATION_AXE_ROLL_UNWIND = 'NEGOTIATION_AXE_ROLL_UNWIND',
  NEGOTIATION_REPO_TYPE = 'NEGOTIATION_REPO_TYPE',
  NEGOTIATION_BOND_PRICE = 'NEGOTIATION_BOND_PRICE',
  NEGOTIATION_LAST_INITIATOR = 'NEGOTIATION_LAST_INITIATOR',
  NEGOTIATION_LAST_RESPONDER = 'NEGOTIATION_LAST_RESPONDER',
  NEGOTIATION_CREATED_AT_DATE = 'NEGOTIATION_CREATED_AT_DATE',
  NEGOTIATION_CREATED_AT_TIME = 'NEGOTIATION_CREATED_AT_TIME',
  NEGOTIATION_UPDATED_BY = 'NEGOTIATION_UPDATED_BY',
  NEGOTIATION_UPDATED_AT_DATE = 'NEGOTIATION_UPDATED_AT_DATE',
  NEGOTIATION_UPDATED_AT_TIME = 'NEGOTIATION_UPDATED_AT_TIME',
  NEGOTIATION_ACCRUED_INTEREST = 'NEGOTIATION_ACCRUED_INTEREST',
  NEGOTIATION_START_CONSIDERATION = 'NEGOTIATION_START_CONSIDERATION',
  NEGOTIATION_REPO_INTEREST = 'NEGOTIATION_REPO_INTEREST',
  NEGOTIATION_END_CONSIDERATION = 'NEGOTIATION_END_CONSIDERATION',
  NEGOTIATION_MARKET = 'NEGOTIATION_MARKET',
  NEGOTIATION_TRADE_DATE = 'NEGOTIATION_TRADE_DATE',
  NEGOTIATION_TRADE_TIME = 'NEGOTIATION_TRADE_TIME',
  NEGOTIATION_TRADE_TYPE = 'NEGOTIATION_TRADE_TYPE',
  NEGOTIATION_NOTICE_PERIOD_DAYS = 'NEGOTIATION_NOTICE_PERIOD_DAYS',
  NEGOTIATION_RFQ_TYPE = 'NEGOTIATION_RFQ_TYPE',
  NEGOTIATION_PRE_AGREED = 'NEGOTIATION_PRE_AGREED',
  NEGOTIATION_MASTER_LEGAL_AGREEMENT = 'NEGOTIATION_MASTER_LEGAL_AGREEMENT',
  INVESTMENT_DECISION_MAKER = 'INVESTMENT_DECISION_MAKER',
  EXECUTION_DECISION_MAKER = 'EXECUTION_DECISION_MAKER',

  // Trading Entity fields
  BLOCK_TRADE = 'BLOCK_TRADE',
  FUND_NAME = 'FUND_NAME',
  FUND_LEI = 'FUND_LEI',
  FUND_BIC = 'FUND_BIC',
  FUND_FIRM = 'FUND_FIRM',
  FUND_FIRM_LEI = 'FUND_FIRM_LEI',
  COUNTERPARTY_NAME = 'COUNTERPARTY_NAME',
  COUNTERPARTY_LEI = 'COUNTERPARTY_LEI',
  COUNTERPARTY_BIC = 'COUNTERPARTY_BIC',
  COUNTERPARTY_FIRM = 'COUNTERPARTY_FIRM',
  COUNTERPARTY_FIRM_LEI = 'COUNTERPARTY_FIRM_LEI',

  // Collateral fields
  COLLATERAL_ISIN_OR_BUI = 'COLLATERAL_ISIN_OR_BUI',
  COLLATERAL_CURRENCY = 'COLLATERAL_CURRENCY',
  COLLATERAL_NAME = 'COLLATERAL_NAME',
  COLLATERAL_CUSIP = 'COLLATERAL_CUSIP',
  COLLATERAL_COUPON = 'COLLATERAL_COUPON',
  COLLATERAL_ISSUER = 'COLLATERAL_ISSUER',

  // Product fields
  PRODUCT = 'PRODUCT',
  PRODUCT_SECTOR = 'PRODUCT_SECTOR',
  REFERENCE_RATE_NAME = 'REFERENCE_RATE_NAME',

  BOOK_NAME = 'BOOK_NAME',
  STRATEGY_NAME = 'STRATEGY_NAME',
  BUNDLE_NAME = 'BUNDLE_NAME',
  NOTES = 'NOTES',
  ALLOW_PARTIAL = 'ALLOW_PARTIAL',

  // Fix fields
  EXTERNAL_NEGOTIATION_ID = 'EXTERNAL_NEGOTIATION_ID',
  EXTERNAL_ORDER_ID = 'EXTERNAL_ORDER_ID',
  ORDER_ID = 'ORDER_ID',
  EXTERNAL_QUOTE_ID = 'EXTERNAL_QUOTE_ID',
  EXTERNAL_QUOTE_RESPONSE_ID = 'EXTERNAL_QUOTE_RESPONSE_ID'
}
